import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  AddressConstraint,
  DadataLocationsConstraint,
  IDadataRootResponse,
} from '../interfaces/dadata.interface';
import { map, take } from 'rxjs/operators';

@Injectable()
export class Dadata2Service {
  private dadataSuggestionUrl = environment.dadataSuggestionUrl;
  private dadataToken = environment.dadataToken;

  private headers = {
    'Content-type': 'application/json',
    Authorization: 'Token ' + this.dadataToken,
  };

  public suggestions$ = new BehaviorSubject([]);

  constructor(private http: HttpClient) {}

  /**
   * Поиск по дадатe
   * @param {string} query
   * @param {string} part
   * @returns {void}
   */
  public searchFio(query: string, part?: string): void {
    this.http
      .post<IDadataRootResponse>(
        this.dadataSuggestionUrl + '/suggest/fio',
        { query, parts: [part] },
        { headers: this.headers }
      )
      .pipe(
        take(1),
        map((v) => v.suggestions.map((v) => v.value))
      )
      .subscribe((res) => this.suggestions$.next(res));
  }

  /**
   * Поиск по дадатe
   * @param {string} query
   * @param {string} part
   * @returns {void}
   */
  public searchEmail(query: string): void {
    this.http
      .post<IDadataRootResponse>(
        this.dadataSuggestionUrl + '/suggest/email',
        { query },
        { headers: this.headers }
      )
      .pipe(
        take(1),
        map((v) => v.suggestions.map((v) => v.value))
      )
      .subscribe((res) => this.suggestions$.next(res));
  }

  /**
   * Подсказки по адресам
   * @param query
   * @param bound
   * @param constraint
   */
  public searchAddress(
    query: string,
    bound?: string | { from: string; to: string },
    constraint?: DadataLocationsConstraint
  ) {
    this.http
      .post<IDadataRootResponse>(
        this.dadataSuggestionUrl + '/suggest/address',
        {
          from_bound: {
            value: typeof bound === 'string' ? bound : bound.from,
          },
          to_bound: {
            value: typeof bound === 'string' ? bound : bound.to,
          },
          restrict_value: true,
          locations: [constraint],
          query,
        },
        { headers: this.headers }
      )
      .pipe(take(1))
      .subscribe((res) => this.suggestions$.next(res.suggestions));
  }

  /**
   * Поиск значения поля "Кем выдан паспорт" по коду подразделения
   * @param query
   */
  findIssuedBy(query: string) {
    return this.http
      .post<IDadataRootResponse>(
        this.dadataSuggestionUrl + '/suggest/fms_unit',
        { query: query, count: 10 },
        { headers: this.headers }
      )
      .pipe(
        take(1),
        map((value) => {
          const dataList = value.suggestions;

          if (dataList.length && dataList[0] && dataList[0].value) {
            return dataList[dataList.length - 1].value;
          }
        })
      );
  }

  /**
   * Получение адреса по коду fias
   * @param fiasCode
   */
  getAddressByFiasCode(fiasCode: string) {
    return this.http.post<IDadataRootResponse>(
      this.dadataSuggestionUrl + '/findById/fias',
      { query: fiasCode },
      { headers: this.headers }
    );
  }
}
